import { render, staticRenderFns } from "./GenesisG80Disclosure.vue?vue&type=template&id=3fd12bef&"
import script from "./GenesisG80Disclosure.vue?vue&type=script&lang=js&"
export * from "./GenesisG80Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports